export default {
  menus: {
    // 公共
    index: '首页',
    // 一级
    workplace: '工作台',
    content: '内容管理',
    column: '栏目管理',
    config: '配置',
    statistics: '网站统计',
    interact: '互动',
    social: '社交媒体',
    vip: '会员',
    system: '系统',
    siteMessage: '站内信',
    notFound: '404',
    authority: '无权限访问',
    service: '服务市场',
    // 二级
    serviceIndex: '服务市场',
    workplaceIndex: '工作台',
    workplaceWorkflow: '我的工作流',
    inMail: '站内消息',
    contentIndex: '内容管理',
    contentDetail: '编辑内容',
    contentCreate: '新增内容',
    columnIndex: '栏目管理',
    columnPermission: '栏目权限管理',
    docPermission: '文档权限管理',
    socialWeibo: '微博',
    socialWechat: '微信',
    // 系统
    organize: '组织管理',
    role: '角色管理',
    user: '用户管理',
    model: '模型管理',
    resource: '资源库',
    safe: '账户安全设置',
    security: '密级管理',
    storage: '存储管理',
    thirdParty: '第三方登录设置',
    sms: '短信服务设置',
    email: '邮件服务设置',
    weixin: '微信开放平台设置',
    firewall: '防火墙设置',
    backup: '数据备份',
    log: '日志管理',
    configSite: '站点管理',
    configTemplates: '模板管理',
    configFiles: '文件管理',
    configInformation: '消息模板管理',
    configContent: '内容索引',
    configTiming: '定时任务',
    configWorkflow: '工作流',
    configWorkflowIndex: '工作流',
    configWorkflowCreate: '新建工作流',
    configWorkflowDetail: '工作流详情',
    systemInfo: '系统信息',
    systemInfoIndex: '系统信息',
    district: '区域管理',
    districtIndex: '区域管理',
    threeMember: '三员管理',
    hierarchical: '分级保护',
    // 会员
    vipCheckPending: '待审核会员',
    vipMember: '会员管理',
    vipGroupName: '会员组管理',
    vipGrade: '会员等级',
    vipIntegral: '积分配置',
    // 配置
    // 互动
    interactComment: '评论管理',
    interactCollect: '采集管理',
    interactCollectIframe: '智能采集',
    interactCollectCreateFast: '快速采集任务',
    interactCollectCreateCustom: '自定义采集任务',
    interactCollectDetail: '采集任务详情',
    interactBlogroll: '友情链接',
    interactVote: '投票调查',
    interactVoteIndex: '投票调查',
    interactVoteCreate: '投票调查-新增',
    interactVoteDetail: '投票调查-修改',
    interactVoteView: '查看问卷',
    interactSmart: '智能表单',
    interactSmartIndex: '智能表单',
    interactSmartDetail: '智能表单-详情',
    interactSmartView: '查看详情',
    interactLetter: '领导信箱',
    interactLetterForm: '表单列表',
    interactLetterFormIndex: '表单列表',
    interactLetterFormDetail: '表单列表-编辑',
    interactLetterType: '信件类型管理',
    interactLetterTypeIndex: '信件类型管理',
    interactLetterBoxIndex: '信箱管理',
    interactLetterMy: '我的信箱',
    interactLetterMyIndex: '我的信箱',
    interactQueAndAns: '你问我答',
    // 网站统计
    statisticsGeneral: '网站概况',
    statisticsFlow: '流量分析',
    statisticsSource: '来源分析',
    statisticsInterviewer: '受访分析',
    statisticsVisitor: '访客分析',
    socialWechatMenu: '菜单管理',
    socialWechatMenuIndex: '菜单管理',
    socialWechatMaterial: '素材管理',
    socialWechatMaterialIndex: '素材管理',
    socialWechatStatistics: '统计汇总',
    socialWechatFansStatistics: '粉丝统计',
    socialWechatApplet: '小程序代码管理',
    socialWechatFans: '粉丝管理',
    socialWechatFansIndex: '粉丝管理',
    socialWechatMessage: '消息管理',
    socialWechatMessageIndex: '消息管理',
    socialWechatPush: '推送管理',
    socialWechatPushIndex: '推送管理',
    socialWechatPushDetail: '推送管理-详情',
    socialWechatFansSend: '粉丝管理-发送消息',
    socialWechatGroup: '定时群发',
    socialWechatGroupIndex: '定时群发',
    socialWechatComment: '留言管理',
    socialWechatCommentIndex: '留言管理',
    statisticsRelease: '内容发布统计',
    statisticsInformation: '内容数据统计',
    // 三级
    // 系统
    organizeIndex: '组织管理',
    organizeDetail: '组织管理-详情',
    organizeMember: '组织管理-成员管理',
    organizePermission: '组织管理-权限分配',
    roleIndex: '角色管理',
    roleEdit: '角色管理-修改',
    roleMember: '角色管理-成员管理',
    rolePermission: '角色管理-权限分配',
    userIndex: '用户管理',
    userCreate: '用户管理-详情',
    userPermission: '用户管理-权限分配',
    modelColumn: '栏目模型管理',
    modelColumnIndex: '栏目模型管理',
    modelColumnDetail: '栏目模型管理详情',
    modelContent: '内容模型管理',
    modelContentIndex: '内容模型管理',
    modelContentDetail: '内容模型管理详情',
    modelNewContentDetail: '内容模型管理详情',
    statisticsReleaseColumn: '栏目',
    modelVip: '会员模型管理',
    modelVipIndex: '会员模型管理',
    modelVipDetail: '会员模型管理详情',
    resourceIndex: '资源库',
    systemSetting: '系统设置',
    systemSettingIndex: '系统设置',
    singleLoginSetting: '单点登录设置',
    safeIndex: '账户安全设置',
    securityUser: '人员密级',
    securityUserIndex: '人员密级',
    securityUserDetail: '人员密级详情',
    securityContent: '内容密级',
    securityContentIndex: '内容密级',
    securityContentDetail: '内容密级详情',
    securityAccessory: '附件密级',
    securityAccessoryIndex: '附件密级',
    securityAccessoryDetail: '附件密级详情',
    storageIndex: '存储管理',
    thirdPartyIndex: '第三方登录设置',
    smsIndex: '短信服务设置',
    emailIndex: '邮件服务设置',
    weixinIndex: '微信开放平台设置',
    firewallIndex: '防火墙设置',
    backupIndex: '数据备份',
    logIndex: '日志管理',
    logRealTime: '实时日志',
    logSystem: '系统日志',
    logBusiness: '业务日志',
    logAudit: '审计日志',
    logSafety: '安全日志',
    logReport: '告警日志',
    logBackups: '日志备份',
    logStrategy: '日志策略',
    logStatistics: '日志统计',
    logRealTimeIndex: '实时日志',
    logSystemIndex: '系统日志',
    logBusinessIndex: '业务日志',
    logAuditIndex: '审计日志',
    logSafetyIndex: '安全日志',
    logReportIndex: '告警日志',
    logBackupsIndex: '日志备份',
    logStrategyIndex: '日志策略',
    logStatisticsIndex: '日志统计',
    menus: '菜单管理',
    menusMenus: '菜单管理',
    menusMenusIndex: '菜单列表',
    menusMenusDetail: '菜单详情',
    menusMenusCreate: '新增菜单',
    menusApis: '接口管理',
    menusApisIndex: '接口列表',
    menusApisDetail: '接口详情',
    storageFtp: 'FTP',
    storageFtpIndex: 'FTP',
    storageFtpDetail: 'FTP详情',
    storageCloud: 'OSS云存储',
    storageCloudIndex: 'OSS云存储',
    storageCloudDetail: '云存储详情',
    configContentIndex: '内容索引',
    configTimingIndex: '定时任务',
    threeMemberSetting: '三员管理设置',
    threeMemberAudit: '三员审核',
    threeMemberJournal: '三员审核日志',
    doubleIndex: '双因子设置',
    performance: '绩效管理',
    performanceIndex: '绩效管理',
    performanceAdd: '创建评分规则',
    performanceDetail: '绩效管理-详情',
    performanceList: '绩效管理-评分结果',
    performanceExamine: '绩效管理-查看绩效列表',
    performanceExamineDetail: '绩效管理-查看绩效详情',
    hierarchicalSettin: '分级保护设置',
    hierarchicalSecret: '用户密级设置',
    hierarchicalJournal: '用户日志',
    // 配置
    configSiteIndex: '站点管理',
    configSiteDetail: '站点详情',
    configSitePermissionSite: '站点权限分配',
    configSitePermissionSiteGroup: '站群权限分配',
    configTemplateseIndex: '模板管理',
    configTemplatesDetail: '模板编辑',
    configFilesIndex: '文件管理',
    configFilesDetail: '文件编辑',
    configInformationIndex: '消息模板管理',
    configInformationDetail: '消息模板管理详情',
    configVocabulary: '词汇管理',
    configSiteStatic: '静态页',
    configAudit: '内容智能审核',
    // 会员
    vipCheckPendingIndex: '待审核会员',
    vipCheckPendingDetail: '会员详情',
    vipMemberIndex: '会员管理',
    vipMemberDetail: '会员详情',
    vipMemberCreate: '新建会员',
    vipGroupNameIndex: '会员组管理',
    vipGroupNameDetail: '会员组详情',
    vipGradeIndex: '会员等级',
    vipIntegralIndex: '积分配置',
    vipGroupNameMembersIndex: '会员组成员管理',
    // 互动
    interactCommentIndex: '评论管理',
    interactCommentContent: '内容评论管理',
    interactCommentMember: '会员评论管理',
    interactCommentIp: 'IP评论管理',
    interactCommentForbidIndex: '禁言管理',
    interactCommentForbidMember: '用户禁言管理',
    interactCommentForbidIp: 'IP禁言管理',
    interactCommentReport: '举报管理',
    interactCollectIndex: '采集管理',
    interactBlogrollIndex: '链接分类',
    interactBlogrollDetail: '友情链接',
    interactQueAndAnsIndex: '提问列表',
    interactAnsList: '回答列表',
    // 媒体
    socialWeiboApplication: '应用配置',
    socialWeiboApplicationIndex: '应用配置',
    socialWeiboAccount: '账号管理',
    socialWeiboAccountIndex: '账号管理',
    socialWeiboFans: '粉丝管理',
    socialWeiboFansIndex: '粉丝管理',
    socialWeiboMessage: '消息管理',
    socialWeiboMessageIndex: '消息管理',
    socialWeiboPushRecord: '推送记录',
    socialWeiboPushRecordIndex: '推送记录',
    socialWechatAuthorization: '授权管理',
    socialWechatAuthorizationIndex: '授权管理',
    socialWechatPublicDetail: '微信公众号-配置详情',
    socialWechatAppletDetail: '微信小程序-配置详情',
    socialWechatMenuDefaultAdd: '默认菜单-新增',
    socialWechatIndividualizationAdd: '个性化菜单-新增',
    socialWechatMenuDefaultDetail: '默认菜单-详情',
    socialWechatIndividualizationDetail: '个性化菜单-详情',
    socialWechatMaterialImageTextAdd: '图文-新增',
    socialWechatMaterialImageTextEdit: '图文-修改',
    socialWechatAutoReply: '自动回复',
    socialWechatAutoReplyIndex: '自动回复',
    socialWechatStatisticsIndex: '统计',
    socialWechatFansStatisticsIndex: '粉丝统计',
    socialWechatAppletIndex: '小程序代码管理',
    // 网站统计
    // 网站概况
    statisticsGeneralIndex: '网站概况',
    statisticsFlowIndex: '实时访客',
    statisticsFlowTendency: '趋势分析',
    statisticsSourceIndex: '全部来源',
    statisticsSourceSearch: '搜索引擎',
    statisticsSourceLink: '外部链接',
    statisticsInterviewerIndex: '受访页面',
    statisticsInterviewerEntrance: '入口页面',
    statisticsVisitorTerritory: '地域分布',
    statisticsVisitorNetwork: '网络设备',
    statisticsVisitorVisitor: '新老访客',
    statisticsVisitorFidelity: '忠诚度',
    statisticsReleaseColumns: '按栏目',
    statisticsReleaseUser: '按用户',
    statisticsReleaseOrganization: '按组织',
    statisticsReleaseSiteview: '按站点',
    statisticsInformationIndex: '按栏目',
    statisticsInformationSingle: '按单篇内容',
    // 四级
    // 配置
    configVocabularyTag: 'tag词',
    configVocabularyTagIndex: 'tag词',
    configVocabularySensitive: '敏感词',
    configVocabularySensitiveIndex: '敏感词',
    configVocabularySearch: '搜索词',
    configVocabularySearchIndex: '搜索词',
    configVocabularyHot: '热词',
    configVocabularyHotIndex: '热词',
    configVocabularyHotDetail: '热词-详情',
    configVocabularySource: '来源管理',
    configVocabularySourceIndex: '来源管理',
    configVocabularySourceDetail: '来源管理-详情',
    configVocabularyContent: '内容类型管理',
    configVocabularyContentIndex: '内容类型管理',
    configVocabularyFontsize: '发文字号管理',
    configVocabularyFontsizeIndex: '发文字号管理',
    configVocabularyFontsizeDetail: '发文字号管理-详情',
    configVocabularyHotManage: '热词-热词管理',
    configAuditManage: '审核策略管理',
    configAuditColumnSetting: '审核栏目设置',
    configAuditModelSetting: '审核模型设置',
    // 内容
    wechatPublicEdit: '推送到微信公众号-编辑',
    sinaWeiboEdit: '推送到新浪微博-编辑'
  }
}
